export default __webpack_public_path__ + "static/media/B-day-coordination.54a1805c.jpg";